import * as React from 'react';
import {NotionWrapper} from '@ux/notion-api';

const NotionFigmaStart = () => (
	<NotionWrapper blockMap={{
	"blocks": [
		{
			"id": "51181f46-f9ad-4d25-b2c3-a59f7c7b8587",
			"type": "page",
			"properties": {
				"title": [
					[
						"Начало работы"
					]
				]
			},
			"content": [
				"10dfb977-0896-41e6-83df-515717fd3460",
				"9a1a9c25-e80d-4eee-91bb-ef39d95ff414",
				"53e231ba-5f0e-423b-8533-aa13e2ad54be",
				"f62a7946-95b4-448f-8ee0-3c601d6d7ddb",
				"5743f913-71ff-41eb-91d4-8d05ac5ef347",
				"6e302bdf-c716-4859-a302-8570e0547f3a",
				"c5f932eb-d3b1-46e9-9f1a-91d317cb1a47",
				"2c6e4be9-f3f3-47d2-aa8a-372882f404a0",
				"d73bd056-95e9-4f13-8fc3-ee0f06830ce0",
				"62748f0c-6ea2-44da-9162-f799ffb82aab",
				"ad4f95f0-8cf9-4813-8dcc-ecc439d6ef38",
				"04e0a6a8-d1b5-48e9-9817-983fa1198b49",
				"76ad6a70-238d-4826-9987-575e57c4424d",
				"e32d49d9-869e-4803-90f2-5500cd6e0377",
				"50236fd4-1ee2-4754-b9a4-11857df7a510",
				"3955fd91-8222-4853-aada-a4bee7bdbe33",
				"6f95b044-e59c-4684-ad38-9f0d1c6977e9",
				"4217751a-fbb5-4322-ac55-891ce8718f75",
				"638d2744-6a7a-442d-a078-9282a3f7d542",
				"476edd29-623b-4182-8d18-9ecc98690fb3",
				"263b3325-22f3-4dae-846a-04f5e45dda33",
				"89bd1377-2406-4144-b786-dd0126202e1f",
				"00d2c69c-60f6-475d-8fdb-19be18effe83",
				"0b881d09-71be-4243-885a-20dbec48c7ff",
				"b5997031-895b-4ca1-8842-6b1b389fd21e",
				"5f8c2e8c-8c51-401f-a5b1-1b095275a65e",
				"cb298638-cab8-4009-a932-dd4705ff6a04",
				"2cf1d4c8-ccf9-4ad7-9b92-6b5aad5ed834",
				"6474a12e-0947-4ef4-80b8-787748e81004",
				"0c49dd06-c4db-454d-9e2e-d3dafb9c11f3",
				"2d2ad946-4b69-4166-99b3-fab78c77d1df",
				"c9d4c439-5d32-431e-b099-cfe1eb35c0d1",
				"9ce42bff-facb-4b1f-8b59-cd072094aced",
				"a58a85ae-ac9d-4e92-ab16-b47d4701db99",
				"07e5308c-ef5d-4845-93b5-14c3f8c6ce3b",
				"8a3e2f3b-c353-4a99-8fa3-7fdf0766c1d4",
				"7b772fd7-9260-4cf2-bdcc-e517d5612223",
				"ef167f26-9a95-465d-bcb0-a44ca0d6a504"
			],
			"format": {
				"copied_from_pointer": {
					"id": "8eb7658d-be10-499c-9e42-1204db5d1d62",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				},
				"page_cover_position": 0.6
			},
			"parent_id": "a7f0ba9f-a91a-4924-8447-b93845e6da1c",
			"parent_table": "block",
			"file_ids": [
				"3e0687e8-ec17-4d5f-affb-d48573c2a717"
			],
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "a7f0ba9f-a91a-4924-8447-b93845e6da1c",
			"type": "page",
			"properties": {
				"title": [
					[
						"Paradigm"
					]
				]
			},
			"content": [
				"d4e0a1ac-e02e-4158-9d96-534ae9fa2c53",
				"b091b55a-a32c-4567-82d7-65c50636e3a7",
				"4e937b6d-4b2c-45c6-ab8c-e9dc9fa9bc2a",
				"7adbd680-541d-4e6e-97d1-f277bd1610c0",
				"ec15c567-4038-4c10-81bb-0a86aee56b08",
				"9a57d34b-41d2-40e4-8c4d-132953b7a175",
				"da552996-155b-442f-9ecf-0bdce521a35e",
				"1f51d543-236b-4b29-a278-4bed543f50b5",
				"5f304e57-18f8-4cd9-b80b-07951787740a",
				"f5097b73-1152-4e95-8919-54eed014af82",
				"94cd6ab9-c518-4094-829c-36d8a73e8010",
				"88cf99fd-dc9d-4649-8601-eb5198351e06",
				"d21336ae-ecfc-4130-a757-19109a89ad74",
				"e916c9a3-5983-4c34-bec3-187e417c593c",
				"cd7c41d2-ae59-4c69-b7d6-4254cf727ff5",
				"7ba8f4fe-6d71-4e1f-a1eb-1df9e3da0099",
				"31c9a6bd-328b-4869-aecd-fabd86f3cf15",
				"cb2b1b2c-b795-4abf-b11f-772b33e43908",
				"a47c1d35-578a-4679-8907-d8b13ab1bb65",
				"41e2749d-ddd3-4a06-b224-0ae6b4c9d436",
				"c3e7c6b7-650d-456d-8997-a4d049587d58",
				"7472c506-f9da-4f2e-85ba-59623551e747",
				"16b738c5-499f-42a0-baf4-cffb990a0b25",
				"51181f46-f9ad-4d25-b2c3-a59f7c7b8587",
				"e8ea6408-fc0d-4be8-8020-e982cc7c9b55",
				"3143e3ff-a6eb-4e48-8197-d96fceb48f9e",
				"20802187-e25a-4d38-af64-a363ffcace1d",
				"311c23ba-4ac6-48a0-bf3b-de8b115c363f",
				"aec03706-7113-42af-8724-4b446502d53a",
				"4836526c-ce6a-4bfd-8c2f-4bcb9a446e1e",
				"e0b8f319-a947-4c5d-8bdf-cd0ffeea5a6d",
				"aa0d9786-1b50-47f5-bc1f-9ec3e47ccd69",
				"98a66dbd-731e-498f-9c5f-7790d1f555e0",
				"c7ec9e06-de22-4861-88e6-e6d45e0de285",
				"55690b50-0664-4442-9ded-4645f2f318e9"
			],
			"parent_id": "1fcd74a2-648f-4dfc-a4d8-abbb9a7bfb29",
			"parent_table": "team",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "10dfb977-0896-41e6-83df-515717fd3460",
			"type": "code",
			"properties": {
				"title": [
					[
						"<meta type=\"url\" value=\"/figma/start\"/>"
					]
				],
				"language": [
					[
						"JavaScript"
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "789f328d-8ce0-4d12-9843-8f0a3041d273",
					"table": "block",
					"spaceId": "22066aad-9295-4afc-88d1-dae5d26fea31"
				}
			},
			"parent_id": "51181f46-f9ad-4d25-b2c3-a59f7c7b8587",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "9a1a9c25-e80d-4eee-91bb-ef39d95ff414",
			"type": "header",
			"properties": {
				"title": [
					[
						"Доступ"
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "83afcb42-a62f-4f74-8908-8d8f4977b63e",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "51181f46-f9ad-4d25-b2c3-a59f7c7b8587",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "53e231ba-5f0e-423b-8533-aa13e2ad54be",
			"type": "text",
			"properties": {
				"title": [
					[
						"Как у дизайнера VK, у вас есть корпоративный доступ к Figma. Достаточно зарегистрироваться в сервисе под своим корпоративным почтовым адресом — @vk.team"
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "8ed60140-870c-46e8-98d0-11abd8e7bfd1",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "51181f46-f9ad-4d25-b2c3-a59f7c7b8587",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "f62a7946-95b4-448f-8ee0-3c601d6d7ddb",
			"type": "sub_sub_header",
			"properties": {
				"title": [
					[
						"Добавление участников"
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "b477b2f6-0e25-473c-b406-64bf202ec365",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "51181f46-f9ad-4d25-b2c3-a59f7c7b8587",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "5743f913-71ff-41eb-91d4-8d05ac5ef347",
			"type": "text",
			"properties": {
				"title": [
					[
						"Чтобы добавить в файл разработчиков и исследователей, поделитесь ссылкой. Можно поделится ссылкой на весь файл или на конкретные экраны. Настройте доступ по ссылке, укажите какой группе людей доступен файл. Если вам нужно поделится только с одним человеком, отправьте ему приглашение."
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "1603ec16-8f40-467c-8b77-81794998459d",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "51181f46-f9ad-4d25-b2c3-a59f7c7b8587",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "6e302bdf-c716-4859-a302-8570e0547f3a",
			"type": "image",
			"properties": {
				"size": [
					[
						"333.2KB"
					]
				],
				"title": [
					[
						"Untitled"
					]
				],
				"source": [
					[
						"https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/0f141c69-c7b7-4373-9b7c-a6fc9dad249f/Untitled.png"
					]
				]
			},
			"format": {
				"block_width": 720,
				"display_source": "https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/0f141c69-c7b7-4373-9b7c-a6fc9dad249f/Untitled.png",
				"block_full_width": false,
				"block_page_width": true,
				"block_aspect_ratio": 0.6533333333333333,
				"block_preserve_scale": true
			},
			"parent_id": "51181f46-f9ad-4d25-b2c3-a59f7c7b8587",
			"parent_table": "block",
			"file_ids": [
				"0f141c69-c7b7-4373-9b7c-a6fc9dad249f"
			],
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31",
			"path": "/notionStatic/6e302bdf-c716-4859-a302-8570e0547f3a.png"
		},
		{
			"id": "c5f932eb-d3b1-46e9-9f1a-91d317cb1a47",
			"type": "quote",
			"properties": {
				"title": [
					[
						"Убедитесь, что добавляемый пользователь имеет доступ только на просмотр и не получает права редактирования. Редактор — платная роль."
					]
				]
			},
			"format": {
				"page_icon": "💡",
				"block_color": "gray_background",
				"copied_from_pointer": {
					"id": "3d16801e-2345-43fe-87d8-188456cac5fa",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "51181f46-f9ad-4d25-b2c3-a59f7c7b8587",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "2c6e4be9-f3f3-47d2-aa8a-372882f404a0",
			"type": "header",
			"properties": {
				"title": [
					[
						"Команды"
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "0b6e525b-1229-47ef-8dab-216d9d8543bc",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "51181f46-f9ad-4d25-b2c3-a59f7c7b8587",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "d73bd056-95e9-4f13-8fc3-ee0f06830ce0",
			"type": "text",
			"properties": {
				"title": [
					[
						"Наша организационная и файловая структуры стремятся ускорить рабочий процесс дизайнера. Для этого нужна интуитивно понятная иерархия, определенное место хранения файлов и понятная система именования."
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "e62be75b-9873-4d6a-b717-7a127ec57cc4",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "51181f46-f9ad-4d25-b2c3-a59f7c7b8587",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "62748f0c-6ea2-44da-9162-f799ffb82aab",
			"type": "text",
			"properties": {
				"title": [
					[
						"Организация VK в Figma разделена на команды продуктов. Вы можете присоединиться к нескольким командам и иметь доступ к разным проектам, экспериментам и файлам."
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "3eb780d8-9cd6-4e0c-9ac3-211099eafeac",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "51181f46-f9ad-4d25-b2c3-a59f7c7b8587",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "ad4f95f0-8cf9-4813-8dcc-ecc439d6ef38",
			"type": "text",
			"properties": {
				"title": [
					[
						"Разрешения Figma устанавливаются на уровне каждой команды. Можно быть членом нескольких команд, каждая из которых имеет собственные разрешения. В каждой команде есть администратор, который предоставляет доступ для редактирования новым дизайнерам."
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "6092f26b-0f9b-4edd-a56d-06f8c7015a3b",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "51181f46-f9ad-4d25-b2c3-a59f7c7b8587",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "04e0a6a8-d1b5-48e9-9817-983fa1198b49",
			"type": "text",
			"properties": {
				"title": [
					[
						"Чтобы найти владельца команды, присоединитесь к ней. Затем перейдите во вкладку с участниками и свяжитесь с администратором, если вам нужны определенные разрешения на файлы внутри проекта."
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "41f83a16-51cc-4e25-be6f-b40e33f3b500",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "51181f46-f9ad-4d25-b2c3-a59f7c7b8587",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "76ad6a70-238d-4826-9987-575e57c4424d",
			"type": "image",
			"properties": {
				"size": [
					[
						"234.0KB"
					]
				],
				"title": [
					[
						"Untitled"
					]
				],
				"source": [
					[
						"https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/50f24834-40ed-42de-964e-28823d727a9d/Untitled.png"
					]
				]
			},
			"format": {
				"block_width": 720,
				"display_source": "https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/50f24834-40ed-42de-964e-28823d727a9d/Untitled.png",
				"block_full_width": false,
				"block_page_width": true,
				"block_aspect_ratio": 0.7111111111111111,
				"block_preserve_scale": true
			},
			"parent_id": "51181f46-f9ad-4d25-b2c3-a59f7c7b8587",
			"parent_table": "block",
			"file_ids": [
				"50f24834-40ed-42de-964e-28823d727a9d"
			],
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31",
			"path": "/notionStatic/76ad6a70-238d-4826-9987-575e57c4424d.png"
		},
		{
			"id": "e32d49d9-869e-4803-90f2-5500cd6e0377",
			"type": "text",
			"format": {
				"copied_from_pointer": {
					"id": "15efc4f0-1893-45ad-8c95-297105fb64f2",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "51181f46-f9ad-4d25-b2c3-a59f7c7b8587",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "50236fd4-1ee2-4754-b9a4-11857df7a510",
			"type": "sub_sub_header",
			"properties": {
				"title": [
					[
						"Запрос доступа в команду"
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "3df94f78-9875-4c79-b0fb-ac39122e8c71",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "51181f46-f9ad-4d25-b2c3-a59f7c7b8587",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "3955fd91-8222-4853-aada-a4bee7bdbe33",
			"type": "text",
			"properties": {
				"title": [
					[
						"Иногда при подключении к команде у вас будет доступ только на просмотр файлов. Чтобы получить доступ на редактирование, обратитесь к администратору или создателю проекта. "
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "3d35bb13-7ad1-4b6a-b551-264543b29fdc",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "51181f46-f9ad-4d25-b2c3-a59f7c7b8587",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "6f95b044-e59c-4684-ad38-9f0d1c6977e9",
			"type": "text",
			"properties": {
				"title": [
					[
						"Также им можно задать вопросы по опубликованным библиотекам и шрифтам."
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "969847ea-7944-4d02-ab7d-9dfdc6a3363e",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "51181f46-f9ad-4d25-b2c3-a59f7c7b8587",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "4217751a-fbb5-4322-ac55-891ce8718f75",
			"type": "header",
			"properties": {
				"title": [
					[
						"Роли и лицензии"
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "0e33e561-c0ee-4a1a-8207-02701e0ca725",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "51181f46-f9ad-4d25-b2c3-a59f7c7b8587",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "638d2744-6a7a-442d-a078-9282a3f7d542",
			"type": "text",
			"properties": {
				"title": [
					[
						"Для Figma и Figjam закупаются отдельные лицензии. Вы можете посмотреть какие лицензии у вас подключены в вашем профиле. Мы рекомендуем чтобы дизайнерам давали доступ сразу на два инструмента."
					]
				]
			},
			"parent_id": "51181f46-f9ad-4d25-b2c3-a59f7c7b8587",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "476edd29-623b-4182-8d18-9ecc98690fb3",
			"type": "text",
			"properties": {
				"title": [
					[
						"Для разработчиков существует отдельный вид лицензий для DevMode. Если разработчики спрашивают вас о подключении этого режима, направьте их в отдел тех.поддержки."
					]
				]
			},
			"parent_id": "51181f46-f9ad-4d25-b2c3-a59f7c7b8587",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "263b3325-22f3-4dae-846a-04f5e45dda33",
			"type": "text",
			"properties": {
				"title": [
					[
						"Figma имеет несколько ролей пользователей. Следите, чтобы права на редактирование проектов и файлов были только у дизайнеров."
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "90bfc756-3dcc-4e16-88f5-7f74a47e8810",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "51181f46-f9ad-4d25-b2c3-a59f7c7b8587",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "89bd1377-2406-4144-b786-dd0126202e1f",
			"type": "bulleted_list",
			"properties": {
				"title": [
					[
						"Guest. ",
						[
							[
								"b"
							]
						]
					],
					[
						"Может смотреть и комментировать макеты, прототипы."
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "bc74f1f8-d992-40c0-83c4-58fdf29f2373",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "51181f46-f9ad-4d25-b2c3-a59f7c7b8587",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "00d2c69c-60f6-475d-8fdb-19be18effe83",
			"type": "bulleted_list",
			"properties": {
				"title": [
					[
						"Viewer. ",
						[
							[
								"b"
							]
						]
					],
					[
						"Может смотреть и комментировать макеты и прототипы. Обязательна привязка к корпоративной почте @vk.team."
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "0b39cb2d-7d97-4423-b8e0-b0f9cc36fb39",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "51181f46-f9ad-4d25-b2c3-a59f7c7b8587",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "0b881d09-71be-4243-885a-20dbec48c7ff",
			"type": "bulleted_list",
			"properties": {
				"title": [
					[
						"Editor. ",
						[
							[
								"b"
							]
						]
					],
					[
						"Может редактировать макеты и приглашать Viewer или Guest. Все дизайнеры имеют эту роль. За эту роль мы платим!"
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "ce8d93d6-1efc-4de1-9319-1fbb327f10e5",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "51181f46-f9ad-4d25-b2c3-a59f7c7b8587",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "b5997031-895b-4ca1-8842-6b1b389fd21e",
			"type": "bulleted_list",
			"properties": {
				"title": [
					[
						"Owner",
						[
							[
								"b"
							]
						]
					],
					[
						" или "
					],
					[
						"Admin. ",
						[
							[
								"b"
							]
						]
					],
					[
						"Может добавлять людей с ролью Editor и подключать к проекту дополнительные шрифты и библиотеки."
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "32f0bba2-1088-4218-8f4e-8ecd53a4b586",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "51181f46-f9ad-4d25-b2c3-a59f7c7b8587",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "5f8c2e8c-8c51-401f-a5b1-1b095275a65e",
			"type": "header",
			"properties": {
				"title": [
					[
						"Разрешения"
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "b735cb50-00b3-47ad-a12f-befceb4ad334",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "51181f46-f9ad-4d25-b2c3-a59f7c7b8587",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "cb298638-cab8-4009-a932-dd4705ff6a04",
			"type": "text",
			"properties": {
				"title": [
					[
						"Ваша учетная запись Figma имеет статус Viewer или Guest. Этот уровень доступа распространяется на все команды и проекты."
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "95adef59-da31-40ea-aa96-cb78f5c989a7",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "51181f46-f9ad-4d25-b2c3-a59f7c7b8587",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "2cf1d4c8-ccf9-4ad7-9b92-6b5aad5ed834",
			"type": "sub_sub_header",
			"properties": {
				"title": [
					[
						"Guest"
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "9ee073a5-e823-486c-a2ac-f07ac1cfa404",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "51181f46-f9ad-4d25-b2c3-a59f7c7b8587",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "6474a12e-0947-4ef4-80b8-787748e81004",
			"type": "text",
			"properties": {
				"title": [
					[
						"Наши партнеры за пределами VK могут просматривать прототипы или файлы. В этом статусе они видят только то, к чему вы даете доступ, но не видят всю экосистему проектов VK"
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "89f110bd-89e5-460d-979f-817f3444e767",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "51181f46-f9ad-4d25-b2c3-a59f7c7b8587",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "0c49dd06-c4db-454d-9e2e-d3dafb9c11f3",
			"type": "quote",
			"properties": {
				"title": [
					[
						"Будьте осторожны, предоставляя доступ людям не из VK."
					]
				]
			},
			"format": {
				"page_icon": "💡",
				"block_color": "gray_background",
				"copied_from_pointer": {
					"id": "2bb06a18-da37-4915-befd-ac16d0e24dce",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "51181f46-f9ad-4d25-b2c3-a59f7c7b8587",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "2d2ad946-4b69-4166-99b3-fab78c77d1df",
			"type": "header",
			"properties": {
				"title": [
					[
						"Многопользовательский режим"
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "2b397fc6-323b-4b93-ace6-f9438de73a7f",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "51181f46-f9ad-4d25-b2c3-a59f7c7b8587",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "c9d4c439-5d32-431e-b099-cfe1eb35c0d1",
			"type": "text",
			"properties": {
				"title": [
					[
						"Figma — инструмент для совместной работы. Это значит, что нужно внимательно относиться к тому, как другие люди видят вас в своих файлах."
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "18ba14c2-79d5-489d-89e2-2005d06c272c",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "51181f46-f9ad-4d25-b2c3-a59f7c7b8587",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "9ce42bff-facb-4b1f-8b59-cd072094aced",
			"type": "bulleted_list",
			"properties": {
				"title": [
					[
						"Добавьте фото и реальное имя. \n",
						[
							[
								"b"
							]
						]
					],
					[
						"Аватар поможет понять, кто редактирует макет. Имя поможет найти вас в истории файла. Не нужно стесняться 😉"
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "3d4cbb77-6feb-457d-9777-bd4ba5c66bf8",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "51181f46-f9ad-4d25-b2c3-a59f7c7b8587",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "a58a85ae-ac9d-4e92-ab16-b47d4701db99",
			"type": "bulleted_list",
			"properties": {
				"title": [
					[
						"Приветствуйте. \n",
						[
							[
								"b"
							]
						]
					],
					[
						"Если вы зашли в файл который кто-то редактирует, обозначьте себя. Можно либо помахать курсором, или написать что-нибудь в чате."
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "ca4d83bc-e0de-417f-99cf-28fa12612abb",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "51181f46-f9ad-4d25-b2c3-a59f7c7b8587",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "07e5308c-ef5d-4845-93b5-14c3f8c6ce3b",
			"type": "bulleted_list",
			"properties": {
				"title": [
					[
						"Комментируйте. \n",
						[
							[
								"b"
							]
						]
					],
					[
						"Если у вас появились вопросы, добавьте комментарии и отметьте в тексте конкретного человека. Круто получить фидбэк от коллег из другой команды."
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "166e88a5-47e8-4be1-a012-24ebe1555b62",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "51181f46-f9ad-4d25-b2c3-a59f7c7b8587",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "8a3e2f3b-c353-4a99-8fa3-7fdf0766c1d4",
			"type": "bulleted_list",
			"properties": {
				"title": [
					[
						"Уважайте чужие файлы. \n",
						[
							[
								"b"
							]
						]
					],
					[
						"Если хотите отредактировать чужой файл, сделайте копию экрана или отдельную страницу и работайте с ними."
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "923df126-84e9-49e5-a3fd-8962ff896dd0",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "51181f46-f9ad-4d25-b2c3-a59f7c7b8587",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "7b772fd7-9260-4cf2-bdcc-e517d5612223",
			"type": "bulleted_list",
			"properties": {
				"title": [
					[
						"Можно голосом. \n",
						[
							[
								"b"
							]
						]
					],
					[
						"Внутри файла добавлена замечательная возможность созвониться. Можно быстро обсуждать макеты или проводить целые брейнштормы. "
					]
				]
			},
			"parent_id": "51181f46-f9ad-4d25-b2c3-a59f7c7b8587",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "ef167f26-9a95-465d-bcb0-a44ca0d6a504",
			"type": "image",
			"properties": {
				"size": [
					[
						"227.8KB"
					]
				],
				"title": [
					[
						"Untitled"
					]
				],
				"source": [
					[
						"https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/1cc06f80-64e8-44b1-b297-e0209fc83bae/Untitled.png"
					]
				]
			},
			"format": {
				"block_width": 720,
				"display_source": "https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/1cc06f80-64e8-44b1-b297-e0209fc83bae/Untitled.png",
				"block_full_width": false,
				"block_page_width": true,
				"block_aspect_ratio": 0.48333333333333334,
				"block_preserve_scale": true
			},
			"parent_id": "51181f46-f9ad-4d25-b2c3-a59f7c7b8587",
			"parent_table": "block",
			"file_ids": [
				"1cc06f80-64e8-44b1-b297-e0209fc83bae"
			],
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31",
			"path": "/notionStatic/ef167f26-9a95-465d-bcb0-a44ca0d6a504.png"
		}
	],
	"headers": [
		{
			"title": "Доступ",
			"id": "9a1a9c25-e80d-4eee-91bb-ef39d95ff414"
		},
		{
			"title": "Команды",
			"id": "2c6e4be9-f3f3-47d2-aa8a-372882f404a0"
		},
		{
			"title": "Роли и лицензии",
			"id": "4217751a-fbb5-4322-ac55-891ce8718f75"
		},
		{
			"title": "Разрешения",
			"id": "5f8c2e8c-8c51-401f-a5b1-1b095275a65e"
		},
		{
			"title": "Многопользовательский режим",
			"id": "2d2ad946-4b69-4166-99b3-fab78c77d1df"
		}
	]
}} />
);

export default NotionFigmaStart;
